import categoryDescriptionHtml from './categorydescription.component.html';

class CategoryDescriptionController {
    constructor($scope, $sce) {
        'ngInject';

        this.$scope = $scope;
        this.fullDescription = false;
        this.$sce = $sce;
    }

    showFullDescription() {
        this.fullDescription = true;
    }

    get descriptionHtml() {
        return this.$sce.trustAsHtml(JSON.parse(atob(this.description)));
    }
}

let categoryDescriptionComponent = {
    bindings: {
        description: '<'
    },
    template: categoryDescriptionHtml,
    controller: CategoryDescriptionController
};

export default categoryDescriptionComponent;